import { IGoogleAnalytics } from "@neb/lit-storybook";

export const googleTagInitialize = (
  ga: IGoogleAnalytics
) => {
  try {
    let url = `https://www.googletagmanager.com/ns.html?id=${ga.container_id}`;
    url += `&gtm_auth=${ga.auth_key}`;
    url += `&gtm_preview=${ga.environment_id}`;
    url += `&gtm_cookies_win=x`;

    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.height = '0';
    iframe.width = '0';
    document.body.appendChild(iframe);

    const googleTagScript = document.createElement('script');
    googleTagScript.type = 'text/javascript';
    googleTagScript.innerHTML = `
      (function(w,d,s,l,i){
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          'loggedin_state': 'true',
          'application': 'RetirementCompliance'
        });

        w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${ga.auth_key}&gtm_preview=${ga.environment_id}&gtm_cookies_win=x';
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', "${ga.container_id}");
    `;
    document.head.appendChild(googleTagScript);

  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Failed to register google tag manager....: ', error);
  }
};
